import { IRequestMessage } from '@/types/interfaces/IRequestMessage'

export default class RequestMessage implements IRequestMessage {
  avancar: { text: string }
  continuarDepois: { text: string }
  init: { text: string }
  status: boolean
  deleteMessage: string
  post: string
  update: string
  messageFinish: string
  errorApi: string
  errorUpload: string
  search: string

  constructor() {
    this.avancar = {
      text: 'Carregando...',
    }
    this.continuarDepois = { text: 'Enviando...' }
    this.init = { text: 'Carregando...' }
    this.status = true
    this.deleteMessage = 'Deletando...'
    this.post = 'Enviando...'
    this.update = 'Atualizando...'
    this.messageFinish = 'Solicitação enviada com sucesso!'
    this.errorApi = 'Houve um erro no envio dos dados.'
    this.errorUpload = 'Houve um erro ao enviar arquivo.'
    this.search = 'Buscando...'
  }
}
